import {
  IDataMapper,
  IEasyfyEvent,
} from "@shared/easyfy.events/easyfy.eventdata";
import { EventNames } from "@shared/easyfy.events/easyfy.eventhandler";
import { ITrackableElement } from "../easyfy.eventdata";

/* Exporter class */
export class KevelDataMapper implements IDataMapper {
  MapEventData(event: IEasyfyEvent): any {
    var mappedEvent: any;

    switch (event.eventName.toLowerCase()) {
      case EventNames.ElementClick: {
        mappedEvent = this.ClickItemEvent(event);
        break;
      }
    }

    switch (event.eventName.toLowerCase()) {
      case EventNames.ElementImpression: {
        mappedEvent = this.ViewItemEvent(event);
        break;
      }
    }
    return mappedEvent;
  }

  ClickItemEvent = async (event: IEasyfyEvent) => {
    const data = event.data as ITrackableElement | undefined;
    const kevelUrl: string = data?.Properties.get("click-url") ?? "";

    if (kevelUrl) await this.sendToKevel(kevelUrl);
  };

  ViewItemEvent = async (event: IEasyfyEvent) => {
    const data = event.data as ITrackableElement | undefined;
    const kevelUrl: string = data?.Properties.get("impression-url") ?? "";

    if (kevelUrl) await this.sendToKevel(kevelUrl);
  };

  sendToKevel = async (kevelUrl: string) => {
    await fetch(kevelUrl, { mode: "no-cors" }).catch((error) => {
      console.error("Error sending kevel event:", error);
    });
  };
}
